import { render, staticRenderFns } from "./detail_carnet.vue?vue&type=template&id=3c8262c1"
import script from "./detail_carnet.vue?vue&type=script&lang=js"
export * from "./detail_carnet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports